import React from 'react';

export default function Error({
  message,
  title,
}: {
  message: string;
  title: string;
}): React.JSX.Element {
  return (
    <div className='min-h-screen p-6 flex justify-center'>
      <div className='container max-w-screen-lg mx-auto'>
        <div className='bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6'>
          <div className='flex justify-center'>
            <svg
              width={284}
              height={227}
              viewBox='0 0 284 227'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M248.565 144.145C248.565 142.574 249.031 141.038 249.904 139.731C250.777 138.424 252.018 137.406 253.469 136.805C254.921 136.203 256.519 136.046 258.06 136.353C259.601 136.659 261.017 137.416 262.128 138.527C263.239 139.638 263.996 141.054 264.302 142.595C264.609 144.136 264.451 145.734 263.85 147.185C263.249 148.637 262.23 149.878 260.924 150.751C259.617 151.624 258.081 152.09 256.51 152.09C254.403 152.09 252.382 151.253 250.892 149.763C249.402 148.273 248.565 146.252 248.565 144.145ZM71.5049 152.09C69.3978 152.09 67.3769 151.253 65.887 149.763C64.397 148.273 63.5599 146.252 63.5599 144.145C63.5599 142.038 64.397 140.017 65.887 138.527C67.3769 137.037 69.3978 136.2 71.5049 136.2H27.2399C25.1328 136.2 23.1119 135.363 21.622 133.873C20.132 132.383 19.2949 130.362 19.2949 128.255C19.2949 126.148 20.132 124.127 21.622 122.637C23.1119 121.147 25.1328 120.31 27.2399 120.31H72.6399C74.7471 120.31 76.7679 119.473 78.2579 117.983C79.7479 116.493 80.5849 114.472 80.5849 112.365C80.5849 110.258 79.7479 108.237 78.2579 106.747C76.7679 105.257 74.7471 104.42 72.6399 104.42H44.2649C42.1578 104.42 40.1369 103.583 38.647 102.093C37.157 100.603 36.3199 98.5822 36.3199 96.475C36.3199 94.3679 37.157 92.347 38.647 90.8571C40.1369 89.3671 42.1578 88.53 44.2649 88.53H89.6649C87.5578 88.53 85.5369 87.693 84.047 86.203C82.557 84.713 81.7199 82.6922 81.7199 80.585C81.7199 78.4779 82.557 76.457 84.047 74.9671C85.5369 73.4771 87.5578 72.64 89.6649 72.64H154.36C156.467 72.64 158.488 73.4771 159.978 74.9671C161.468 76.457 162.305 78.4779 162.305 80.585C162.305 82.6922 161.468 84.713 159.978 86.203C158.488 87.693 156.467 88.53 154.36 88.53H227C229.107 88.53 231.128 89.3671 232.618 90.8571C234.108 92.347 234.945 94.3679 234.945 96.475C234.945 98.5822 234.108 100.603 232.618 102.093C231.128 103.583 229.107 104.42 227 104.42H251.97C254.077 104.42 256.098 105.257 257.588 106.747C259.078 108.237 259.915 110.258 259.915 112.365C259.915 114.472 259.078 116.493 257.588 117.983C256.098 119.473 254.077 120.31 251.97 120.31H230.405C228.298 120.31 226.277 121.147 224.787 122.637C223.297 124.127 222.46 126.148 222.46 128.255C222.46 130.362 223.297 132.383 224.787 133.873C226.277 135.363 228.298 136.2 230.405 136.2H237.215C239.322 136.2 241.343 137.037 242.833 138.527C244.323 140.017 245.16 142.038 245.16 144.145C245.16 146.252 244.323 148.273 242.833 149.763C241.343 151.253 239.322 152.09 237.215 152.09H71.5049Z'
                fill='#DBEAFE'
              />
              <path
                d='M189.871 150.566C189.871 150.566 185.369 155.443 182.243 158.02C179.117 160.597 174.038 163.818 174.038 163.818C167.493 167.449 160.265 169.679 152.812 170.365C143.982 171.189 135.083 169.865 126.875 166.506C119.88 163.635 113.56 159.339 108.317 153.892C104.976 150.439 102.102 146.564 99.7672 142.366C93.9021 131.794 91.7203 119.572 93.5656 107.624C95.4108 95.6756 101.178 84.681 109.96 76.3714C118.741 68.0618 130.037 62.9094 142.068 61.7258C154.1 60.5423 166.183 63.3948 176.415 69.834C182.725 73.818 188.164 79.0361 192.406 85.1748C199.133 94.8747 202.523 106.499 202.066 118.294C201.609 130.089 197.328 141.416 189.871 150.566Z'
                fill='white'
                stroke='#3B82F6'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
              />
              <path
                d='M200.328 51.075V57.885'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M200.328 66.965V73.775'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M188.978 62.4249H195.788'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M204.867 62.4249H211.677'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M106.123 167.98V172.52'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M106.123 181.6V186.14'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M97.0425 177.06H101.582'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M110.663 177.06H115.203'
                stroke='#60A5FA'
                strokeWidth='2.5'
                strokeMiterlimit={10}
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M110.087 84.2968C109.643 84.8251 109.71 85.6136 110.239 86.0581C110.767 86.5026 111.555 86.4347 112 85.9065L110.087 84.2968ZM114.432 81.4709L115.301 82.3696L115.302 82.3686L114.432 81.4709ZM130.713 71.1543L131.905 70.7784C131.802 70.4509 131.568 70.1804 131.26 70.0302C130.951 69.8801 130.594 69.8635 130.273 69.9844L130.713 71.1543ZM129.522 71.5327C129.729 72.1911 130.431 72.5565 131.09 72.3488C131.748 72.1412 132.113 71.4392 131.906 70.7808L129.522 71.5327ZM102.891 95.8044C102.61 96.4348 102.893 97.174 103.523 97.4554C104.154 97.7369 104.893 97.4541 105.174 96.8237L102.891 95.8044ZM105.473 93.359L106.577 93.946L106.578 93.9427L105.473 93.359ZM108.826 90.1542C109.207 89.5783 109.049 88.8028 108.473 88.4222C107.897 88.0416 107.121 88.2 106.741 88.7759L108.826 90.1542ZM112 85.9065C113.039 84.6718 114.141 83.4912 115.301 82.3696L113.563 80.5722C112.342 81.7534 111.181 82.9966 110.087 84.2968L112 85.9065ZM115.302 82.3686C119.842 77.9698 125.237 74.5509 131.153 72.3242L130.273 69.9844C124.036 72.3318 118.348 75.936 113.562 80.5732L115.302 82.3686ZM129.521 71.5303L129.522 71.5327L131.906 70.7808L131.905 70.7784L129.521 71.5303ZM105.174 96.8237C105.612 95.8427 106.081 94.8775 106.577 93.946L104.37 92.7719C103.845 93.7576 103.351 94.7747 102.891 95.8044L105.174 96.8237ZM106.578 93.9427C107.259 92.6547 108.019 91.3755 108.826 90.1542L106.741 88.7759C105.89 90.063 105.088 91.4125 104.368 92.7752L106.578 93.9427Z'
                fill='#60A5FA'
              />
              <path
                d='M153.11 143.918C153.11 145.466 152.515 146.942 151.467 148.025C150.421 149.106 149.011 149.705 147.55 149.705C146.089 149.705 144.679 149.106 143.633 148.025C142.585 146.942 141.99 145.466 141.99 143.918C141.99 142.37 142.585 140.894 143.633 139.811C144.679 138.73 146.089 138.131 147.55 138.131C149.011 138.131 150.421 138.73 151.467 139.811C152.515 140.894 153.11 142.37 153.11 143.918ZM143.633 83.5153C144.679 82.4344 146.089 81.835 147.55 81.835C149.011 81.835 150.421 82.4344 151.467 83.5153C152.515 84.5977 153.11 86.0742 153.11 87.622V124.055C153.11 125.603 152.515 127.08 151.467 128.162C150.421 129.243 149.011 129.842 147.55 129.842C146.089 129.842 144.679 129.243 143.633 128.162C142.585 127.08 141.99 125.603 141.99 124.055V87.622C141.99 86.0742 142.585 84.5977 143.633 83.5153Z'
                fill='#BFDBFE'
                stroke='#3B82F6'
                strokeWidth='2.5'
              />
            </svg>
          </div>
          <div className='form-state-page-title'>{title}</div>
          <div className='form-state-page-subtitle my-1'>{message}</div>
          <div className='form-state-page-subtitle my-2'>
            Give us a call at{' '}
            <span className='text-blue-600 form-state-page-subtitle'>
              <a href='tel:276.531.9260'>(276) 531-9260</a>
            </span>{' '}
            or email as directly{' '}
            <span className='text-blue-600 form-state-page-subtitle'>
              <a href='mailto:support@snap-raise.com'>support@snapraise.com</a>
            </span>
            .{' '}
          </div>
        </div>
      </div>
    </div>
  );
}
